/**
 * Collapsible PCA Orientation Tool Component
 * Wrapper to make OrientationAnalysis collapsible following existing pattern
 */

import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Compass } from 'lucide-react';
import { OrientationAnalysis } from './OrientationAnalysis';
import { useViewerStore } from '@/store/viewerStore';

export function CollapsibleOrientationTool() {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { isModelLoaded } = useViewerStore();

  return (
    <div className="bg-dark-100 rounded-lg border border-gray-700">
      {/* Header - Always Visible */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-dark-200 transition-colors rounded-lg"
      >
        <div className="flex items-center gap-2">
          <Compass className="w-5 h-5 text-blue-400" />
          <span className="font-semibold text-gray-100">PCA Orientation Analysis</span>
          <span className="text-xs text-white">Find Primary Axis</span>
        </div>
        <div className="flex items-center gap-2">
          {!isCollapsed && (
            <span className="text-xs text-white">
              {isModelLoaded ? '✓ Ready' : '⚠ No Model'}
            </span>
          )}
          {isCollapsed ? (
            <ChevronRight className="w-5 h-5 text-white" />
          ) : (
            <ChevronDown className="w-5 h-5 text-white" />
          )}
        </div>
      </button>

      {/* Collapsible Content */}
      {!isCollapsed && (
        <div className="p-4 border-t border-gray-700 animate-fade-in">
          <OrientationAnalysis />
        </div>
      )}
    </div>
  );
}